import styled from 'styled-components';

const H1 = styled.h1`
  color: ${(props) => props.theme.colors.white01};
  font-size: 2.25rem;
  line-height: 2.625rem;
`;

export default H1;
